import React, { useEffect, useState, useContext } from 'react';
import {
  Grid,
  Typography,
  Box,
  TextField,
  Stack,
  FormLabel,
  FormControl,
  Select,
  MenuItem,
  Chip,
  FormHelperText,
  Backdrop,
  CircularProgress,
  TableContainer,
  Table,
  Button,
} from '@mui/material';
import { useLocation, useSearchParams } from 'react-router-dom';
import { FetchContext } from 'src/context/FetchContext';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { toast } from 'react-hot-toast';
import { createTheme } from '@mui/material';
import { API_ROUTES } from 'src/services/constant';
import MUIDataTable from 'mui-datatables';
import { CalculateBillableCosts } from 'src/components/customecomponent/CalculateBillableCosts';
import Scrollbar from 'src/components/scrollbar';
import DeleteIcon from '@mui/icons-material/Delete';
import Iconify from 'src/components/iconify';
const { PRIVATE_ROUTE } = API_ROUTES;
export default function InvoiceCreateForm({
  initialData,
  register,
  errors,
  getValues,
  setValue,
  handleSubmit,
  onSubmit,
  params,
  loading,
  labourCostArr,
  editData,
  setEditData,
  taxCodeArr,
  salesTax,
  defaultInvoiceItemName,
  defaultSalesTaxName,
}) {

  const todayDate = new Date();
  const [condition, setCondition] = React.useState(params ? getValues('selectClient') : '');
  const [personName, setPersonName] = React.useState('');
  const [taskData, settaskData] = React.useState([]);
  const [selectTask, setSelectTask] = useState();
  const [showloading, setshowLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [jobDetails, setJobDetails] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [formattedDate, setformattedDate] = React.useState(new Intl.DateTimeFormat('en-CA').format(todayDate));
  const [taskId, setTaskId] = useState();
  const [selectedClient, setSelectedClient] = useState();
  const { authAxios } = useContext(FetchContext);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [hours, setHours] = useState(0);
  const [cost, setCost] = useState(0);
  const [focusedRows, setFocusedRows] = useState({});
  const [userTax, setUserTax] = useState('');
  const [taxRate, setTaxRate] = useState([]);
  const [pendingTaskId, setPendingTaskId] = useState(null);
  const [searchParams] = useSearchParams();
  const getTaskId = searchParams.get('taskId');
  const clientId = searchParams.get('clientId');

  const totalTaxableCost = invoices
    .filter((item) => item.sales_tax_value) // Get only TAX items
    .reduce((sum, item) => sum + item.billable_cost, 0); // Sum billable_cost

  const totalBillableCost = invoices?.reduce((total, item) => total + item.billable_cost, 0);

  const hasTax = invoices.some((item) => item.sales_tax_value);

  const totalHours = invoices?.reduce((total, item) => total + item.dwr_hours, 0);
  setValue('labourCosts', invoices);
  setValue('CustomerMemo', jobDetails);
  setValue('subTotal', totalBillableCost);
  setValue('totalHours', totalHours);
  setValue('taxCodeRef', userTax);

  let clientState = 'selectClient';

  const stateData = clientState.split('.');

  let checked = 'checked';

  let errorMassage = false;

  if (!checked) {
    if (
      errors !== null &&
      errors[`${stateData[0]}`] &&
      errors[`${stateData[0]}`][`${stateData[1]}`] &&
      errors[`${stateData[0]}`][`${stateData[1]}`][`${stateData[2]}`]
    ) {
      errorMassage = true;
    }
  } else if (errors !== null && errors[`${stateData[0]}`]) {
    errorMassage = true;
  }

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName?.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    };
  }

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setshowLoading(true);
      const filteredArray = editData?.lines?.filter((item) => item.Id !== undefined);
      const taxValueId =
        editData?.qb_response?.TxnTaxDetail?.TxnTaxCodeRef?.value;
      const hasChackedTax = taxValueId
        ? String(taxValueId)
        : String(userTax || '');
      const taxMatchObj = salesTax?.find(
        (item) => String(item.Id) === String(hasChackedTax)
      );
      const taxRateDecimal = taxMatchObj?.TaxRate / 100;
      setTaxRate(taxRateDecimal);
      setformattedDate(filteredArray[0]?.SalesItemLineDetail?.ServiceDate);
      if (salesTax?.some((tax) => String(tax.Id) === hasChackedTax)) {
        setUserTax(hasChackedTax);
      }
      const CustomerMemo = editData?.qb_response?.CustomerMemo?.value
        .split('')
        .map((line) => line.trim())
        .join('');
      const job_data = editData?.job_details?.locations;
      const outputData = filteredArray?.map((item, index) => {
        const tax_value = item?.SalesItemLineDetail?.TaxCodeRef;
        const taxValue = item?.SalesItemLineDetail?.TaxCodeRef?.value;
        const matchingTax = salesTax?.find(
          (tax) => String(tax.Id) === String(taxValue)
        );
        const taxRate =
          matchingTax?.SalesTaxRateList?.TaxRateDetail ?? [];
        return {
          index: index + 1,
          cost_item: item.SalesItemLineDetail.ItemRef.name,
          dwr_hours: item.SalesItemLineDetail.Qty,
          unit_cost: item.SalesItemLineDetail.UnitPrice,
          billable_cost: item.Amount,
          value: item.SalesItemLineDetail.ItemRef.value,
          description: item?.Description,
          sales_tax_value: matchingTax?.Id,
          sales_tax: matchingTax?.Name,
          service_date: item.SalesItemLineDetail.ServiceDate
            ? item.SalesItemLineDetail.ServiceDate
            : editData?.qb_response?.TxnDate,
          taxRateDecimal: taxRate
        };
      });
      const task_obj = {
        job_number: editData?.job_details?.number_str,
        hours: editData?.total_hours,
        cost: editData?.total_cost,
        task_details: editData?.task_details,
      };
      const TASK_DATA = {
        label: editData?.task_details?.number_str,
        id: editData?.task_details?._id,
      };
      if (labourCostArr.length !== 0 && salesTax.length !== 0) {
        getClientTaskData(editData?.client_id?._id, editData?.task_details?._id);
      }
      setValue('SyncToken', editData?.SyncToken);
      setValue('labourCosts', outputData);
      setValue('CustomerMemo', CustomerMemo);
      setValue('subTotal', editData?.total_cost);
      setValue('totalHours', editData?.total_hours);
      setValue('taskIds', editData?.task_ids);
      setValue('selectClient_referenceno', editData?.client_ref_id);
      setValue('selectClient', editData?.client_id?.company_name);
      setValue('selectClient_id', editData?.client_id?._id);
      setValue('qb_invoice_id', editData?.qb_invoice_id);
      setTaskId(editData?.task_details?._id);
      settaskData([TASK_DATA]);
      setInvoices(outputData);
      setJobDetails(CustomerMemo);
      setSelectTask(task_obj);
      setSelectedClient(editData?.client_id);
      setSiteAddress(
        `${job_data?.[0]?.munciple_address},${job_data?.[0]?.city},${job_data?.[0]?.state},${job_data?.[0]?.postal_code}`
      );
      setshowLoading(false);
    }
  }, [editData, salesTax, labourCostArr]);

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: 'red' },
        },
      },
    },
  });

  const handleFocus = (index) => {
    setFocusedRows((prev) => ({
      ...prev,
      [index]: true,
    }));
  };

  const handleBlur = (index) => {
    setFocusedRows((prev) => ({
      ...prev,
      [index]: false,
    }));
  };

  const handleRowDelete = async (e, i) => {
    let rawIndex = i - 1;
    let updatedInvoices = [...invoices];
    updatedInvoices = updatedInvoices.filter((_, index) => index !== rawIndex);
    updatedInvoices = updatedInvoices.map((item, index) => ({
      ...item,
      index: index + 1,
    }));
    setInvoices(updatedInvoices);
  };

  function handleTaxChange(index, value, taxRateDecimal, obj) {
    const matchingTax = salesTax?.find((item) => String(item.Id) === String(value));
    let updatedInvoices = [...invoices];
    if (matchingTax) {
      updatedInvoices[index] = {
        ...updatedInvoices[index],
        index: index + 1,
        sales_tax: matchingTax?.Name,
        sales_tax_value: value,
        taxRateDecimal: obj,
      };
    }
    setInvoices(updatedInvoices);
  }

  function handleCostItemChange(index, value) {
    const matchingItem = labourCostArr?.find(
      (item) => String(item.value) === String(value)
    );
    if (!matchingItem) return;
    setInvoices((prevInvoices) =>
      prevInvoices.map((invoice, rowIndex) =>
        rowIndex === index
          ? {
            ...invoice,
            index: rowIndex + 1,
            cost_item: matchingItem.cost_item,
            value: matchingItem.value,
          }
          : invoice
      )
    );
  }

  function handleDescriptionChange(index, value) {
    let updatedInvoices = [...invoices];
    updatedInvoices[index] = {
      ...updatedInvoices[index],
      description: value,
    };
    setInvoices(updatedInvoices);
  }

  function handleDwrHoursChange(index, value) {
    let updatedInvoices = [...invoices];
    const total_billable_cost = value ? updatedInvoices[index].unit_cost * parseFloat(value) : 0;
    updatedInvoices[index] = {
      ...updatedInvoices[index],
      dwr_hours: parseFloat(value),
      billable_cost: total_billable_cost,
    };
    setInvoices(updatedInvoices);
  }

  function handleUnitCostChange(index, value) {
    let updatedInvoices = [...invoices];
    const total_billable_cost = value ? parseFloat(value) * updatedInvoices[index].dwr_hours : 0;
    updatedInvoices[index] = {
      ...updatedInvoices[index],
      unit_cost: parseFloat(value),
      billable_cost: total_billable_cost,
    };
    setInvoices(updatedInvoices);
  }

  function AddLabourCost() {
    const add_row = {
      index: invoices.length + 1,
      cost_item: '',
      dwr_hours: 1,
      unit_cost: 0,
      billable_cost: 0,
      description: '',
      value: '',
      sales_tax_value: '',
      sales_tax: '',
      service_date: formattedDate,
      taxRateDecimal: [],
    };
    setInvoices((prevInvoices) => [...prevInvoices, add_row]);
  }

  const taxSummary = invoices.reduce((acc, item) => {
    if (Array.isArray(item.taxRateDecimal)) {
      item.taxRateDecimal.forEach((tax) => {
        let taxName = tax.TaxRateRef.name;
        let taxRate = tax.RateValue / 100; // Convert percentage to decimal
        if (!acc[taxName]) {
          acc[taxName] = {
            sales_tax: taxName,
            totalBillableCost: 0,
            taxRateDecimal: taxRate,
            taxAmount: 0,
          };
        }
        acc[taxName].totalBillableCost += Number(item.billable_cost);
        acc[taxName].taxAmount = (acc[taxName].totalBillableCost * taxRate).toFixed(2);
      });
    }
    return acc;
  }, {});

  const totalWithTax = Object.values(taxSummary).reduce((sum, taxItem) => {
    return sum + Number(taxItem.taxAmount);
  }, 0).toFixed(2);

  useEffect(() => {
    if (pendingTaskId === null) return;
    const Selected_Task_Obj = taskData.find(
      (item) => String(item.id) === String(pendingTaskId)
    );
    if (!Selected_Task_Obj) return;
    const job_data = Selected_Task_Obj?.task_details?.job_id?.locations;
    const defaultItem = labourCostArr?.find(
      (item) =>
        item.cost_item?.trim().toLowerCase() ===
        String(defaultInvoiceItemName || '').trim().toLowerCase()
    );
    const defaultTax = salesTax?.find(
      (tax) =>
        tax.Name?.trim().toLowerCase() ===
        String(defaultSalesTaxName || '').trim().toLowerCase()
    );

    const defaultTaxDetails =
      defaultTax?.SalesTaxRateList?.TaxRateDetail ?? [];

    if (!editData || Object.keys(editData).length === 0) {
      setInvoices([
        {
          index: 1,
          cost_item: defaultItem?.cost_item ?? '',
          dwr_hours: 1,
          unit_cost: Selected_Task_Obj?.cost ?? 0,
          billable_cost: Selected_Task_Obj?.cost ?? 0,
          description:
            Selected_Task_Obj?.task_details?.task_scope_id?.name,
          value: String(defaultItem?.value ?? ''),
          service_date: formattedDate,
          sales_tax_value: String(defaultTax?.Id ?? ''),
          sales_tax: defaultTax?.Name ?? '',
          taxRateDecimal: defaultTaxDetails,
        },
      ]);
      setJobDetails(
        `Job#${Selected_Task_Obj?.job_number}Task#${Selected_Task_Obj?.task_details?.number_str}Site Address: ${job_data?.[0]?.munciple_address}, ${job_data?.[0]?.city}, ${job_data?.[0]?.state}, ${job_data?.[0]?.postal_code}`
      );
    }
    setSiteAddress(
      `${job_data?.[0]?.munciple_address},${job_data?.[0]?.city},${job_data?.[0]?.state},${job_data?.[0]?.postal_code}`
    );
    setSelectTask(Selected_Task_Obj);
    setValue('taskIds', Selected_Task_Obj.id);
    setValue(
      'selectClient_referenceno',
      Selected_Task_Obj?.task_details?.client_id?.qb_customer_id
    );
    setTaskId(Selected_Task_Obj.id);
    setPendingTaskId(null);
  }, [pendingTaskId, taskData, editData, formattedDate, setValue, labourCostArr, defaultInvoiceItemName, salesTax, defaultSalesTaxName,]);

  useEffect(() => {
    if (!defaultInvoiceItemName || !labourCostArr?.length) return;

    const defaultItem = labourCostArr.find(
      (item) =>
        item.cost_item?.trim().toLowerCase() ===
        String(defaultInvoiceItemName).trim().toLowerCase()
    );

    if (!defaultItem) {
      console.warn(
        'Default QuickBooks item name not found:',
        defaultInvoiceItemName
      );
      return;
    }

    setInvoices((prevInvoices) => {
      // Apply the default only to the first empty row.
      if (!prevInvoices.length) return prevInvoices;

      const firstRow = prevInvoices[0];

      // Don't overwrite an existing selection or edit-invoice data.
      if (firstRow.cost_item || firstRow.value) {
        return prevInvoices;
      }

      const updatedInvoices = [...prevInvoices];

      updatedInvoices[0] = {
        ...firstRow,
        cost_item: defaultItem.cost_item,
        value: defaultItem.value,
      };

      return updatedInvoices;
    });
  }, [defaultInvoiceItemName, labourCostArr]);

  useEffect(() => {
    if (!defaultSalesTaxName || !salesTax?.length) return;

    // Do not apply defaults while editing an existing invoice.
    if (editData && Object.keys(editData).length > 0) return;

    const defaultTax = salesTax.find(
      (tax) =>
        tax.Name?.trim().toLowerCase() ===
        String(defaultSalesTaxName).trim().toLowerCase()
    );

    if (!defaultTax) {
      console.warn(
        'Default QuickBooks sales tax not found:',
        defaultSalesTaxName
      );
      return;
    }

    const taxDetails =
      defaultTax.SalesTaxRateList?.TaxRateDetail ?? [];

    setInvoices((prevInvoices) => {
      if (!prevInvoices.length) return prevInvoices;

      const firstRow = prevInvoices[0];

      // Preserve any tax the user has already selected.
      if (firstRow.sales_tax_value || firstRow.sales_tax) {
        return prevInvoices;
      }

      const updatedInvoices = [...prevInvoices];

      updatedInvoices[0] = {
        ...firstRow,
        sales_tax: defaultTax.Name,
        sales_tax_value: String(defaultTax.Id),
        taxRateDecimal: taxDetails,
      };

      return updatedInvoices;
    });
  }, [defaultSalesTaxName, salesTax, editData]);

  function handleTaskChange(e) {
    const { value } = e.target;
    // Save the selected task and wait for salesTax to load.
    setPendingTaskId(value);
  }

  async function getClientTaskData(clientId, task_id) {
    try {
      const { data } = await authAxios.get(`${PRIVATE_ROUTE.GET_TASK_DATA}/${clientId}?taskId=${task_id}`);
      const Selected_client_obj = initialData?.client?.find((item) => item.id === clientId);
      setValue('selectClient', Selected_client_obj?.label || '');
      setValue('selectClient_id', Selected_client_obj?.id || '');
      setSelectedClient(Selected_client_obj || null);
      const uniqueTasksMap = new Map();
      data?.data?.forEach((item) => {
        if (!uniqueTasksMap.has(item._id)) {
          uniqueTasksMap.set(item._id, item);
        }
      });
      const task_arr = Array.from(uniqueTasksMap.values()).map((item) => {
        // console.log('data-----1>', item);
        const totalOfDwrCost = CalculateBillableCosts(item);
        const totalBilebleSum = totalOfDwrCost.reduce((acc, curr) => acc + curr.totalCost, 0);
        const totalSpenHours = totalOfDwrCost.reduce((acc, curr) => acc + curr.taskHours, 0);
        return {
          label: item.number_str,
          id: item._id,
          job_number: item?.job_id?.number_str || '',
          hours: totalSpenHours || 0,
          cost: totalBilebleSum || 0,
          task_details: item || {},
        };
      });
      settaskData(task_arr);
      setCount(data.total || 0);
      setshowLoading(false);
      const selectedTask = task_arr.find((t) => t.id === task_id);
      if (selectedTask) setSelectTask(selectedTask);
      else setSelectTask(null);
    } catch (error) {
      console.error('Error fetching client task data:', error);
      setshowLoading(false);
    }
  }

  const handleChangeClientField = async (event) => {
    setValue('subTotal', '');
    setValue('totalHours', '');
    setValue('taskIds', '');
    setTaskId();
    setSelectTask();
    settaskData();
    setSelectedClient();
    setshowLoading(true);
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === 'string' ? value?.split(',')[0] : value);
    setValue('selectClient', value?.split(',')[0]);
    setValue('selectClient_id', value?.split(',')[1].trim());
    setPersonName(getValues('selectClient'));
    setCondition(value?.split(',')[0]);
    const clientId = getValues('selectClient_id');
    let task_id;
    if (editData && Object.keys(editData).length > 0 && value?.split(',')[1].trim() === editData?.client_id?._id) {
      task_id = editData.task_ids;
    }
    getClientTaskData(clientId, task_id);
  };

  const columns = [
    {
      name: 'index',
      label: 'No.',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: true,
      },
    },
    {
      name: 'service_date',
      label: 'Service Date',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'cost_item',
      label: 'Cost Item',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const isFocused = focusedRows[rowIndex];

          return (
            <select
              value={String(invoices[rowIndex]?.value ?? '')}
              onFocus={() => handleFocus(rowIndex)}
              onBlur={() => handleBlur(rowIndex)}
              onChange={(e) => {
                handleCostItemChange(rowIndex, e.target.value);
              }}
              style={{
                width: '100%',
                backgroundColor: isFocused ? 'white' : 'transparent',
                border: 'none',
                outline: 'none',
                padding: '8px',
              }}
            >
              <option value="" disabled>
                Select an option
              </option>

              {labourCostArr?.map((item) => (
                <option key={item.value} value={String(item.value)}>
                  {item.cost_item}
                </option>
              ))}
            </select>
          );
        },
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          const isFocused = focusedRows[rowIndex];
          return (
            <input
              type="text"
              value={value || ''}
              onFocus={() => handleFocus(rowIndex)}
              onBlur={() => handleBlur(rowIndex)}
              onChange={(e) => {
                const newValue = e.target.value;
                updateValue(newValue);
                handleDescriptionChange(tableMeta.rowIndex, newValue);
              }}
              style={{
                width: '100%',
                backgroundColor: isFocused ? 'white' : 'transparent',
                border: 'none',
                outline: 'none',
                padding: '8px',
              }}
            />
          );
        },
      },
    },
    {
      name: 'dwr_hours',
      label: 'Qty',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          const isFocused = focusedRows[rowIndex];
          return (
            <input
              type="number"
              value={value || ''}
              onFocus={() => handleFocus(rowIndex)}
              onBlur={() => handleBlur(rowIndex)}
              onChange={(e) => {
                const newValue = e.target.value;
                updateValue(newValue);
                handleDwrHoursChange(tableMeta.rowIndex, newValue);
              }}
              style={{
                width: '100%',
                backgroundColor: isFocused ? 'white' : 'transparent',
                border: 'none',
                outline: 'none',
                padding: '8px',
              }}
              min={1}
            />
          );
        },
      },
    },
    {
      name: 'unit_cost',
      label: 'Amount/Cost',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          const isFocused = focusedRows[rowIndex];
          return (
            <input
              type="number"
              value={value || ''}
              onFocus={() => handleFocus(rowIndex)}
              onBlur={() => handleBlur(rowIndex)}
              onChange={(e) => {
                const newValue = e.target.value;
                updateValue(newValue);
                handleUnitCostChange(tableMeta.rowIndex, newValue);
              }}
              style={{
                width: '100%',
                backgroundColor: isFocused ? 'white' : 'transparent',
                border: 'none',
                outline: 'none',
                padding: '8px',
              }}
              min={0}
            />
          );
        },
      },
    },
    {
      name: 'billable_cost',
      label: 'Billable Amount',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'sales_tax',
      label: 'Sales Tax',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;

          const selectedTaxId = String(
            invoices[rowIndex]?.sales_tax_value ?? ''
          );
          const isFocused = focusedRows[rowIndex];
          return (
            <select
              value={selectedTaxId}
              onFocus={() => handleFocus(rowIndex)}
              onBlur={() => handleBlur(rowIndex)}
              onChange={(e) => {
                const newValue = e.target.value;
                updateValue(newValue);
                const taxMatchObj = salesTax?.find(
                  (item) => String(item.Id) === String(e.target.value)
                );
                const obj =
                  taxMatchObj?.SalesTaxRateList?.TaxRateDetail ?? [];
                const taxRateDecimal = Number(taxMatchObj?.TaxRate ?? 0) / 100;
                handleTaxChange(tableMeta.rowIndex, newValue, taxRateDecimal, obj);
              }}
              style={{
                width: '100%',
                backgroundColor: isFocused ? 'white' : 'transparent',
                border: 'none',
                outline: 'none',
                padding: '8px',
              }}
            >
              <option value="" disabled>
                Select Tax
              </option>
              {salesTax?.map((item) => (
                <option key={item.Id} value={item.Id} className='m-2 p-2'>
                  {item.Name} {"(" + (item.TaxRate ? item.TaxRate : 0) + "% )"}
                </option>
              ))}
            </select>
          );
        },
      },
    },
    {
      name: 'Action',
      lable: 'Action',
      options: {
        filter: false,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              {tableMeta.tableData.length !== 1 && (
                <DeleteIcon
                  onClick={(e) => handleRowDelete(e, tableMeta.rowData[0])}
                />
              )}
            </>
          );
        },
      },
    },
    {
      name: '',
      label: 'value',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
  ];

  const options = {
    selectToolbarPlacement: 'none',
    search: false,
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standard',
    filter: false,
    print: false,
    fixedHeader: true,
    viewColumns: false,
    download: false,
    selectableRows: false,
    pagination: false,
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)' : 'white',
        },
      };
    },
    setTableProps: () => {
      return {
        padding: 'default',
        border: '1px solid rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)',
        size: 'small',
      };
    },
  };

  useEffect(() => {
    if (getTaskId && clientId) {
      getClientTaskData(clientId, getTaskId);
      if (taskData?.length > 0) {
        const selectedTask = taskData.find((task) => task.id === getTaskId);
        if (selectedTask) {
          setTaskId(getTaskId);
          handleTaskChange({ target: { value: getTaskId } });
        }
      }
    }
  }, [salesTax, initialData?.client]);

  return (
    <>
      <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} padding={3}>
          {params ? (
            <>
              <Typography variant="h4" component="h2">
                Edit Invoice
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h4" component="h2">
                Create Invoice
              </Typography>
            </>
          )}
          <Grid>
            <Grid container spacing={5}>
              <Grid md={6} xs={12} item>
                <FormLabel>
                  Select Client<span style={{ color: 'red' }}>*</span>
                </FormLabel>
                <FormControl fullWidth>
                  <Select
                    fullWidth
                    className={errorMassage ? 'error-input-border' : ''}
                    onChange={(e) => {
                      handleChangeClientField(e);
                    }}
                    value={getValues('selectClient') || ''}
                    defaultValue={getValues('selectClient') || ''}
                    rules={{ required: true }}
                    inputProps={
                      <>
                        <TextField
                          {...register('selectClient', {
                            required: '**Field is required',
                          })}
                          error={Boolean(errorMassage)}
                          helperText={errorMassage ? '*Field is required' : null}
                        />
                      </>
                    }
                    renderValue={(selected) => {
                      return (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.1 }}>
                          <Chip label={selected?.split(',')[0]} sx={{ backgroundColor: '#65C8D0', color: 'white' }} />
                        </Box>
                      );
                    }}
                  >
                    {initialData?.client?.map((name) => {
                      return (
                        <MenuItem
                          key={name.id}
                          selected={personName === name.label}
                          value={`${name.label},${name.id}`}
                          style={getStyles(name.label, personName, theme)}
                        >
                          {name.label === '' ? 'no data found' : name.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText className="error_msg">{errorMassage ? '**Field is required ' : ''}</FormHelperText>
                </FormControl>
              </Grid>
              {getValues('selectClient') && (
                <>
                  <Grid xs={12} item md={6}>
                    <FormLabel>
                      <>Client Email (Will be used for quickbook integration)</>
                    </FormLabel>
                    <TextField
                      fullWidth
                      type="text"
                      value={selectedClient?.company_email}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 50 }}
                      slotProps={{
                        input: {
                          readOnly: true,
                        },
                      }}
                    />
                  </Grid>
                  {/* <Grid md={6} xs={12} item>
                    <FormLabel>
                      Select Task<span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                    <FormControl fullWidth>
                      <Select
                        fullWidth
                        value={taskId || ''}
                        onChange={(e) => handleTaskChange(e)}
                        displayEmpty
                        className={errors.taskIds ? 'error-input-border' : ''}
                        rules={{ required: true }}
                        inputProps={
                          <>
                            <TextField
                              {...register('taskIds', {
                                required: '**Field is required',
                              })}
                              error={Boolean(errors.taskIds)}
                              helperText={errors.taskIds ? '*Field is required' : null}
                            />
                          </>
                        }
                        renderValue={(selected) => {
                          const selectedTaskObj = taskData?.find((task) => task.id === taskId);
                          return (
                            <>
                              {taskId && (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.1 }}>
                                  <Chip
                                    key={selected}
                                    label={selectedTaskObj?.label}
                                    sx={{ backgroundColor: '#65C8D0', color: 'white' }}
                                  />
                                </Box>
                              )}
                            </>
                          );
                        }}
                      >
                        {taskData?.map((name) => {
                          return (
                            <MenuItem
                              key={name.id}
                              selected={name.label}
                              value={name.id}
                              style={getStyles(name.label, personName, theme)}
                            >
                              {name.label === '' ? 'no data found' : name.label}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {errors.taskIds && (
                        <FormHelperText className="error_msg">
                          {errors.taskIds?.message ? '**Field is required ' : ''}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid> */}
                  <Grid md={6} xs={12} item>
                    <FormLabel>
                      Select Task<span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                    <FormControl fullWidth error={Boolean(errors.taskIds)}>
                      <Select
                        fullWidth
                        value={taskId || ''}
                        onChange={(e) => handleTaskChange(e)}
                        displayEmpty
                        className={errors.taskIds ? 'error-input-border' : ''}
                        renderValue={(selected) => {
                          const selectedTaskObj = taskData?.find((task) => task.id === selected);
                          return selected ? (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.1 }}>
                              <Chip
                                key={selected}
                                label={selectedTaskObj?.label}
                                sx={{ backgroundColor: '#65C8D0', color: 'white' }}
                              />
                            </Box>
                          ) : (
                            'Select Task'
                          );
                        }}
                      >
                        {taskData?.length > 0 ? (
                          taskData.map((task) => (
                            <MenuItem
                              key={task.id}
                              value={task.id} // ✅ this is enough
                              style={getStyles(task.label, personName, theme)}
                            >
                              {task.label || 'no data found'}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled value="">
                            No tasks found
                          </MenuItem>
                        )}
                      </Select>
                      {errors.taskIds && (
                        <FormHelperText className="error_msg">
                          {errors.taskIds?.message || '*Field is required'}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </>
              )}
              {taskId && (
                <>
                  <Grid xs={12} item md={6}>
                    <FormLabel>
                      <>Job</>
                    </FormLabel>
                    <TextField
                      fullWidth
                      type="text"
                      value={selectTask?.job_number || ''}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 50 }}
                      slotProps={{
                        input: {
                          readOnly: true,
                        },
                      }}
                    />
                  </Grid>
                  <Grid xs={12} item md={6}>
                    <FormLabel>
                      <>Billable Hours</>
                    </FormLabel>
                    <TextField
                      fullWidth
                      type="text"
                      value={selectTask?.hours || ''}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 50 }}
                      slotProps={{
                        input: {
                          readOnly: true,
                        },
                      }}
                    />
                  </Grid>
                  <Grid xs={12} item md={6}>
                    <FormLabel>
                      <>Billable Cost</>
                    </FormLabel>
                    <TextField
                      fullWidth
                      type="text"
                      value={selectTask?.cost || ''}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 50 }}
                      slotProps={{
                        input: {
                          readOnly: true,
                        },
                      }}
                    />
                  </Grid>
                  <Grid xs={12} item md={6}>
                    <FormLabel>
                      <>Description</>
                    </FormLabel>
                    <TextField
                      fullWidth
                      type="text"
                      value={selectTask?.task_details?.task_scope_id?.name || ''}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 50 }}
                      slotProps={{
                        input: {
                          readOnly: true,
                        },
                      }}
                    />
                  </Grid>
                  {siteAddress && (
                    <Grid xs={12} item md={6}>
                      <FormLabel>
                        <>Site Address</>
                      </FormLabel>
                      <TextField
                        fullWidth
                        multiline
                        type="text"
                        value={siteAddress}
                        InputLabelProps={{ shrink: true }}
                        slotProps={{
                          input: {
                            readOnly: true,
                          },
                        }}
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
            {showloading ? (
              <div>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={showloading}>
                  <CircularProgress color="inherit" />
                </Backdrop>
              </div>
            ) : (
              ''
            )}
          </Grid>
          {taskId && (
            <>
              <Typography variant="h6" component="h2">
                Billing Line Items
              </Typography>
              <Grid>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                      <MUIDataTable options={options} columns={columns} data={invoices} />
                      {loading && (
                        <div>
                          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                            <CircularProgress color="inherit" />
                          </Backdrop>
                        </div>
                      )}
                    </Table>
                  </TableContainer>
                </Scrollbar>
              </Grid>
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <Button variant="contained" onClick={AddLabourCost} startIcon={<Iconify icon="eva:plus-fill" />}>
                    Add Lines
                  </Button>
                  <Grid container mt={2}>
                    <Grid xs={12} item>
                      <FormLabel>
                        <>Message on invoice</>
                      </FormLabel>
                      <TextField
                        fullWidth
                        multiline
                        type="text"
                        value={jobDetails}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => setJobDetails(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={6}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'end',
                      gap: '80px',
                      marginBottom: '8px',
                    }}
                  >
                    <Typography variant="h5" className="m-2" align="end" sx={{ paddingRight: '10px' }}>
                      SubTotal:
                    </Typography>
                    <Typography variant="h5" align="end" sx={{ paddingRight: '10px', width: '98px' }}>
                      {totalBillableCost}
                    </Typography>
                  </div>
                  <Grid container item xs={12} md={12}>
                    <Grid item xs={12} md={12}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '0px' }}>
                        {Object.values(taxSummary).map((taxItem, i) => (
                          <>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '90px', justifyContent: 'end' }}>
                              <span style={{ fontWeight: 'bold' }}>
                                {taxItem.sales_tax} @{Math.round(taxItem.taxRateDecimal * 100)}% on{' '}
                                {taxItem.totalBillableCost}
                              </span>
                              <FormControl sx={{ maxWidth: '90px' }}>
                                <>
                                  <TextField
                                    key={i}
                                    inputProps={{
                                      'aria-label': 'Without label',
                                      readOnly: hasTax ? true : false,
                                      style: { textAlign: 'end', padding: '9px 10px' },
                                    }}
                                    value={`${taxItem.taxAmount}`}
                                    disabled={hasTax ? false : true}
                                    variant="outlined"
                                    size="small"
                                  />
                                </>
                              </FormControl>
                            </div>
                          </>
                        ))}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'end',
                          gap: '75px',
                          marginTop: '8px',
                        }}
                      >
                        <Typography variant="h4" component="h2" align="end" sx={{ paddingRight: '10px' }}>
                          Total:
                        </Typography>
                        <Typography
                          variant="h4"
                          component="h2"
                          align="end"
                          sx={{ paddingRight: '10px', width: '98px' }}
                        >
                          {hasTax
                            ? (parseFloat(totalBillableCost) + parseFloat(totalWithTax)).toFixed(2)
                            : totalBillableCost}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid sx={{ display: 'flex' }}>
                <LoadingButton
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  loading={loading}
                  style={{ width: 300 }}
                >
                  Submit
                </LoadingButton>
              </Grid>
            </>
          )}
        </Stack>
      </form>
    </>
  );
}
InvoiceCreateForm.propTypes = {
  register: PropTypes.any,
  params: PropTypes.any,
  errors: PropTypes.object,
  handleSubmit: PropTypes.any,
  onSubmit: PropTypes.func,
  control: PropTypes.any,
  value: PropTypes.any,
  handleChange: PropTypes.func,
};